<app-country-form
    [country]="country"
    [errorObs]="errorObservable"
    (countrySelected)="onCountrySelected($event)">
</app-country-form>